import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../../services/apiServices";
import { endPoints } from "../../../configs/apiUrls";
import { StreetType, FilterType } from "./slice";

/* =========================
   API RESPONSE TYPE
========================= */
interface StreetListResponse {
    filterData: FilterType;
    success: boolean;
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    data: StreetType[];
}

/* =========================
   THUNK PARAMS
========================= */
interface FetchStreetListParams {
    page?: number;
    limit?: number;
    state?: string;
    city?: string;
    area?: string;      // areaId
    search?: string;
    sortBy?: string | null;
    sortOrder?: "asc" | "desc" | null;
    isActive?: boolean | null;
}

/* =========================
   MAIN THUNK
========================= */
export const fetchStreetList = createAsyncThunk<
    StreetListResponse,
    FetchStreetListParams
>(
    "street/fetchStreetList",
    async (
        {
            page = 1,
            limit = 10,
            state = "",
            city = "",
            area = "",
            search = "",
            sortBy = null,
            sortOrder = null,
            isActive = null,
        },
        thunkAPI
    ) => {
        try {
            const params = {
                page,
                limit,
                state: state || undefined,
                city: city || undefined,
                area: area || undefined,
                search: search || undefined,
                sortBy: sortBy || undefined,
                sortOrder: sortOrder || undefined,
                ...(isActive !== null && isActive !== undefined
                    ? { isActive }
                    : {}),
            };

            const response = await apiGet(endPoints.GET_STREET_LIST, params);

            return {
                data: response.data,
                filterData: {
                    isActive,
                    state,
                    city,
                    area,
                    search,
                    page: response.page,
                    limit: response.limit,
                    totalCount: response.total,
                    sortBy,
                    sortOrder,
                },
                success: response.success,
                page: response.page,
                limit: response.limit,
                total: response.total,
                totalPages: response.totalPages,
            };
        } catch (error) {
            return thunkAPI.rejectWithValue("Failed to fetch street list");
        }
    }
);
